import * as React from "react";
import { BidderSearchContainer } from "../components/search-bidders/BidderSearchContainer";
import { Container, Typography, Box } from "@material-ui/core";
import { SecureArea } from "../components/authentication/SecureArea";
import { MemberPermission } from "../services/MemberService";
import { withAITracking } from "@microsoft/applicationinsights-react-js";
import { reactPlugin } from "../services/TelemetryService";

function BidderSearch() {
  return (
    <Container maxWidth={"lg"} fixed>
      <SecureArea memberPermission={MemberPermission.AccountAdmin}>
        <Typography variant="h4" color="primary" gutterBottom>
          Bidder Search
        </Typography>
        <Typography variant="subtitle1" gutterBottom>
          Search for a bidder.
        </Typography>
        <Box mt={4}>
          <BidderSearchContainer />
        </Box>
      </SecureArea>
    </Container>
  );
}

export default withAITracking(reactPlugin, BidderSearch, "BidderSearch");
